<template>
  <div class="dropdown d-inline-block preset-dropdown">
    <button class="btn btn-outline-secondary btn-sm dropdown-toggle preset-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-bookmark me-1"></i> Salvar filtro
    </button>
    <ul class="dropdown-menu dropdown-menu-end shadow-sm preset-menu">
      <li>
        <button class="dropdown-item small preset-item" @click="salvarAtual">
          <i class="bi bi-plus-circle me-2"></i>Salvar combinação atual
        </button>
      </li>
      <li>
        <button class="dropdown-item small preset-item" @click="gerenciar = !gerenciar">
          <i class="bi bi-gear me-2"></i>Gerenciar meus filtros salvos
        </button>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li v-if="presets.length === 0" class="px-3 py-2 text-center preset-empty">Nenhum filtro salvo</li>
      <li v-for="(preset, idx) in presets" :key="idx">
        <div class="dropdown-item d-flex align-items-center justify-content-between small preset-item">
          <button class="btn btn-link text-decoration-none p-0 text-start flex-grow-1 preset-load-btn" @click="carregar(idx)">
            <i class="bi bi-bookmark-fill preset-icon me-2"></i>
            {{ preset.nome }}
            <br><span class="preset-data">{{ preset.data }}</span>
          </button>
          <button v-if="gerenciar" class="btn btn-link text-danger p-0 ms-2 preset-del-btn" @click="deletar(idx)" title="Remover">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </li>
    </ul>

    <div v-if="mostrarModal" class="modal-backdrop fade show" :style="{ zIndex: zIndexEfetivo }" @click="mostrarModal = false"></div>
    <div v-if="mostrarModal" class="modal d-block" :style="{ zIndex: zIndexEfetivo + 1 }" tabindex="-1">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content preset-modal-content">
          <div class="modal-header py-2">
            <h6 class="modal-title">Salvar filtro</h6>
            <button type="button" class="btn-close" @click="mostrarModal = false"></button>
          </div>
          <div class="modal-body py-2">
            <input v-model="nomePreset" type="text" class="form-control form-control-sm" placeholder="Nome do filtro..." @keyup.enter="confirmarSalvar" />
          </div>
          <div class="modal-footer py-1">
            <button class="btn btn-sm btn-secondary" @click="mostrarModal = false">Cancelar</button>
            <button class="btn btn-sm btn-primary" @click="confirmarSalvar">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const STORAGE_KEY = 'bi_saldos_origem_presets'

const props = defineProps({
  filtrosAtuais: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['carregar-preset'])

const mostrarModal = ref(false)
const nomePreset = ref('')
const gerenciar = ref(false)
const presets = ref([])

// --- Empilhamento (z-index) via registry central ---
const tokenZIndex = ref(null)
const zIndexReservado = ref(null)
const zIndexEfetivo = computed(() => zIndexReservado.value ?? BASE_ZINDEX)

watch(mostrarModal, (aberto) => {
  if (aberto) {
    const { token, zIndex: z } = reservarZIndex()
    tokenZIndex.value = token
    zIndexReservado.value = z
  } else {
    liberarZIndex(tokenZIndex.value)
    tokenZIndex.value = null
    zIndexReservado.value = null
  }
})

onUnmounted(() => {
  liberarZIndex(tokenZIndex.value)
  tokenZIndex.value = null
  zIndexReservado.value = null
})

onMounted(() => carregarPresetsStorage())

function carregarPresetsStorage () {
  try {
    const data = localStorage.getItem(STORAGE_KEY)
    presets.value = data ? JSON.parse(data) : []
  } catch { presets.value = [] }
}

function salvarStorage () {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets.value))
}

function salvarAtual () {
  nomePreset.value = ''
  mostrarModal.value = true
}

function confirmarSalvar () {
  if (!nomePreset.value.trim()) return
  presets.value.push({
    nome: nomePreset.value.trim(),
    data: new Date().toLocaleDateString('pt-BR'),
    filtros: JSON.parse(JSON.stringify(props.filtrosAtuais))
  })
  salvarStorage()
  mostrarModal.value = false
  nomePreset.value = ''
}

function carregar (idx) {
  const preset = presets.value[idx]
  if (preset) emit('carregar-preset', JSON.parse(JSON.stringify(preset.filtros)))
}

function deletar (idx) {
  presets.value.splice(idx, 1)
  salvarStorage()
}
</script>

<style scoped>
.preset-btn {
  font-size: 0.8rem;
}

.preset-menu {
  min-width: 220px;
}

.preset-item {
  font-size: 0.8rem;
}

.preset-empty {
  font-size: 0.8rem;
  color: var(--bs-secondary-color);
}

.preset-icon {
  color: var(--bs-warning);
}

.preset-data {
  font-size: 0.65rem;
  color: var(--bs-secondary-color);
}

.preset-load-btn {
  color: var(--bs-body-color);
  font-size: 0.8rem;
}

.preset-del-btn {
  font-size: 0.8rem;
}

.preset-modal-content {
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
}
</style>
